export const servers = {
  real: 'wss://sslsocket.aifanet.com/89.19.27.85/14002'
};
